export default __webpack_public_path__ + "static/media/013.13d5445d.webp";